import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';
import { InputEntidad, DatePickerCustom, InputCodigo, FormLabel, Modal, FormError } from '../../common';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { useFormErrors } from '../../hooks/useFormErrors';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import { isValidNumber } from '../../../utils/validator';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import {TIPS} from "../../../consts/tips";


const CuentaCorrienteCondicionEspecialModal = (props) => {

    //variables
    const entityInit = {
        id: 0,
        numero: '',
        idTipoCondicionEspecial: 0,
        idCuenta: 0,
        numeroPartida: 0,
        codigoDelegacion: '',
        numeroMovimiento : 0,
        numeroComprobante: '',
        fechaDesde: null,
        fechaHasta: null 
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        entity: entityInit
    });

    useEffect(() => {

        const entity = {...entityInit,
            id: props.data.id,
            idCuenta: props.data.idCuenta,
            numeroPartida: props.data.numeroPartida,
            codigoDelegacion: props.data.codigoDelegacion,
            numeroMovimiento: props.data.numeroMovimiento
        }
        setState(prevState => {
            return {...prevState,
                entity: entity };
        });

        if (props.data.id > 0) {
            FindCondicionEspecial();
        }

    }, [props.data]);

    const [ formValues, formHandle, , formSet ] = useForm({
        numero: '',
        idTipoCondicionEspecial: 0,
        numeroComprobante: '',
        fechaDesde: null,
        fechaHasta: null  
    });

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        if (props.data.id === 0) {
            AddCondicionEspecial();
        }
        else {
            ModifyCondicionEspecial();
        }
    }
    const handleClickCancelar = () => {
        props.onDismiss();
    }  

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }  

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoCondicionEspecial <= 0) errors.idTipoCondicionEspecial = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.numero.length <= 0) errors.numero = VALIDATION_MESSAGE.REQUIRED;

        return errors;
    }

    function getFormatErrors() {

        const errors = {};

        if (formValues.numero.length > 0 && !isValidNumber(formValues.numero, true)) errors.numero = 'Ingresá un número mayor a cero';
        if (formValues.numeroComprobante.length > 0 && !isValidNumber(formValues.numeroComprobante, false)) errors.numeroComprobante = 'Ingresá sólo números';

        return errors;
    } 

    function FindCondicionEspecial() {

        setState(prevState => {
          return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                if (data.fechaDesde) data.fechaDesde = new Date(data.fechaDesde);
                if (data.fechaHasta) data.fechaHasta = new Date(data.fechaHasta);

                setState(prevState => {
                  return {...prevState, loading: false, entity: data};
                });
                formSet({
                    numero: data.numero.toString(),
                    idTipoCondicionEspecial: data.idTipoCondicionEspecial,
                    numeroComprobante: data.numeroComprobante.toString(),
                    fechaDesde: data.fechaDesde,
                    fechaHasta: data.fechaHasta
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                  return {...prevState, loading: false};
                });
            });
        };

        const paramsUrl = `/${props.data.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_CONDICION_ESPECIAL,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function AddCondicionEspecial() {
        const method = REQUEST_METHOD.POST;
        const paramsUrl = null;
        SaveCondicionEspecial(method, paramsUrl);
    }

    function ModifyCondicionEspecial() {
        const method = REQUEST_METHOD.PUT;
        const paramsUrl = `/${props.data.id}`;
        SaveCondicionEspecial(method, paramsUrl);
    }    

    function SaveCondicionEspecial(method, paramsUrl) {

        setState(prevState => {
          return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
          response.json()
          .then((row) => {
            setState(prevState => {
                return {...prevState, loading: false};
            });
            props.onConfirm(row.id);
          })
          .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
          });
        };

        const dataBody = {
            ...state.entity,
            numero: (formValues.numero.length > 0) ? parseInt(formValues.numero) : 0,
            idTipoCondicionEspecial: formValues.idTipoCondicionEspecial,
            numeroComprobante: (formValues.numeroComprobante.length > 0) ? parseInt(formValues.numeroComprobante) : 0,
            fechaDesde: formValues.fechaDesde,
            fechaHasta: formValues.fechaHasta
        };

        ServerRequest(
            method,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_CONDICION_ESPECIAL,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
        <Modal
            size="md"
            title={`Condición especial: ${(state.entity.id > 0) ? state.entity.numero : "Nuevo"}`}
            onEscape={() => handleClickCancelar()}
            body={(
                    <div className="row">

                        <div className="mb-3 col-12">
                            <FormLabel htmlFor="idTipoCondicionEspecial" required>Tipo</FormLabel>
                            <InputEntidad
                                name="idTipoCondicionEspecial"
                                tipName={TIPS.NAME.MODALS.TIPO_CONDICION_ESPECIAL_MODAL}
                                placeholder=""
                                className={`form-control ${errorOf('idTipoCondicionEspecial') ? 'is-invalid' : ''}`}
                                value={ formValues.idTipoCondicionEspecial }
                                onChange={ formHandle }
                                disabled={props.disabled}
                                title="Tipo condición especial"
                                entidad="TipoCondicionEspecial"
                                filter={row => !row.idTipoTributo || !props.data.idTipoTributo || row.idTipoTributo === props.data.idTipoTributo}
                            />
                            <FormError message={errorOf('idTipoCondicionEspecial')} />
                        </div>

                        <div className="mb-3 col-6">
                            <FormLabel htmlFor="numero" required>Número</FormLabel>
                            <InputCodigo
                                name="numero"
                                placeholder=""
                                className={`form-control ${errorOf('numero') ? 'is-invalid' : ''}`}
                                value={ formValues.numero }
                                onChange={ formHandle }
                                disabled={props.disabled}
                            />
                            <FormError message={errorOf('numero')} />
                        </div>
                        <div className="mb-3 col-6">
                            <label htmlFor="numeroComprobante" className="form-label">N° comprobante</label>
                            <InputCodigo
                                name="numeroComprobante"
                                placeholder=""
                                className={`form-control ${errorOf('numeroComprobante') ? 'is-invalid' : ''}`}
                                value={ formValues.numeroComprobante }
                                onChange={ formHandle }
                                disabled={props.disabled}
                            />
                            <FormError message={errorOf('numeroComprobante')} />
                        </div>

                        <div className="mb-3 col-6">
                            <label htmlFor="fechaDesde" className="form-label">Fecha desde</label>
                            <DatePickerCustom
                                name="fechaDesde"
                                placeholder=""
                                className="form-control"
                                value={ formValues.fechaDesde }
                                onChange={ formHandle }
                                disabled={props.disabled}
                            />
                        </div>
                        <div className="mb-3 col-6">
                            <label htmlFor="fechaHasta" className="form-label">Fecha hasta</label>
                            <DatePickerCustom
                                name="fechaHasta"
                                placeholder=""
                                className="form-control"
                                value={ formValues.fechaHasta }
                                onChange={ formHandle }
                                disabled={props.disabled}
                                minValue={formValues.fechaDesde}
                            />
                        </div>

                    </div>
            )}
            footer={!props.disabled ? (<>
                    <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Cancelar</button>
                    <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
            </>) : (
                    <button className="btn back-button" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Volver</button>
            )}
            footerClassName={props.disabled ? 'f-align' : ''}
        />
    );
}

CuentaCorrienteCondicionEspecialModal.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
  };
  
  CuentaCorrienteCondicionEspecialModal.defaultProps = {
    disabled: false
  };

export default CuentaCorrienteCondicionEspecialModal;